import { alumni } from "../data";
import { ArrowLink, PageIntro } from "../components/Shell";

const groups = [
  { key: "Faculty", label: "Faculty", ko: "교수" },
  { key: "Doctoral Study", label: "Doctoral study", ko: "박사과정 진학" },
  { key: "Industry", label: "Industry", ko: "기업" }
];

export default function AlumniPage() {
  return (
    <>
      <PageIntro
        label="People"
        title="졸업생"
        aside={
          <>
            Alumni record · {alumni.length}
            <br />
            학위연도와 확인된 진로
          </>
        }
      />
      <section className="page-section shell">
        <div className="section-header">
          <div>
            <p className="section-label">Alumni</p>
            <h2>졸업생 진로</h2>
          </div>
          <ArrowLink to="/people">현재 구성원</ArrowLink>
        </div>
        <div className="alumni-groups">
          {groups.map((group) => {
            const people = alumni.filter((person) => person.group === group.key);
            return (
              <section className="alumni-group" key={group.key}>
                <div>
                  <p className="section-label">{group.label}</p>
                  <h2>{group.ko}</h2>
                </div>
                <div className="alumni-table">
                  {people.map((person) => (
                    <article className="alumni-row" key={`${person.name}-${person.year}`}>
                      <span className="alumni-year">{person.year}</span>
                      <p className="alumni-name">
                        {person.name}
                        {person.role ? ` · ${person.role}` : ""}
                      </p>
                      <p className="alumni-destination">{person.destination}</p>
                    </article>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </section>
    </>
  );
}
